<template>
  <section id="add-truck">
      <main style="text-align:left;white-space:normal">
        <div class="title">
            <icon icoClass='title-ico' selected='criticalLines'/>
            {{$t('add_critical_line')}}
        </div>
        <div class="fields">
            <div class="field">
              <div class="field-half-page">
                <label>{{$t('init_date')}}<span class="mandatory">*</span></label>
                <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="criticalLine.init_date" required/>
              </div>
              <div class="field-half-page">
                <label>{{$t('end_date')}}</label>
                <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="criticalLine.end_date"/>
              </div>
            </div>
            <div class="field">
                <label>{{$t('cause')}}</label>
                <input type="text" v-model="criticalLine.cause"/>
            </div>
            <div class="field">
              <div class="field-half-page">
                  <label>{{$t('activity')}}</label>
                  <input type="text" v-model="criticalLine.activity"/>
              </div>
              <div class="field-half-page">
                  <label>{{$t('line')}}</label>
                  <input type="text" v-model="criticalLine.line"/>
              </div>
            </div>
            <div class="field">
              <div class="field-half-page">
                  <label>{{$t('product')}}</label>
                  <input type="text" v-model="criticalLine.product"/>
              </div>
              <div class="field-half-page">
                  <label>{{$t('contact')}}</label>
                  <input type="text" v-model="criticalLine.contact"/>
              </div>
            </div>
            <div class="field">
              <label>
                {{$t('destination')}}
              </label>
              <input type="text" v-model="criticalLine.destination"/>
            </div>
            <div class="field">
                <label>{{$t('observations')}}</label>
                <textarea @keypress.enter.prevent v-model="criticalLine.observations"/>
            </div>

            <div class="field">
              <div class="field-half-page">
                  <label for="center">{{$t('provider')}}</label>
                  <search-select inputStyle="box-sizing: border-box" url="client" field="description" divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block" @data="criticalLine.provider=$event" :source="criticalLine.provider"/>
              </div>
              <div class="field-half-page">
                <label for="center">{{$t('client_name')}}</label>
                <search-select inputStyle="box-sizing: border-box" url="client" field="description" divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block" @data="criticalLine.client=$event" :source="criticalLine.client"/>
              </div>
            </div>

            <button class="btn-green" @click="save()">{{$t('save')}}</button>
            <button class="btn-black" @click="$router.push('/criticalLines')">{{$t('cancel')}}</button>
        </div>

      </main>
    </section>
</template>
<script>
import icon from './../svg/tabs'
import Modal from './../components/Modal'
import {mapActions, mapState} from 'vuex'
import SearchSelect from './../components/SearchSelect.vue'
import moment from 'moment'
export default {
  name: 'addexp',
  components: {icon, Modal, SearchSelect},
  props: {
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    const promises = [
      this.getClients().then(response => {
        this.clients = response
      })
    ]
    if (this.$route.params && this.$route.params.id) {
      promises.push(this.getCriticalLine(this.$route.params.id).then(response => {
        this.criticalLine = response
        if (this.criticalLine.end_date) this.criticalLine.end_date = moment(this.criticalLine.end_date).format('YYYY-MM-DDTHH:mm:ss')
        if (this.criticalLine.init_date) this.criticalLine.init_date = moment(this.criticalLine.init_date).format('YYYY-MM-DDTHH:mm:ss')
      }))
    }
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      criticalLine: {},
      clients: []
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      company: state => state.auth.company
    })
  },
  methods: {
    ...mapActions({
      saveCriticalLine: 'lines/saveCriticalLine',
      getCriticalLine: 'lines/readCriticalLine',
      getClients: 'clients/list'
    }),
    /* printLabel (criticalLine) {
      if (criticalLine) {
        this.download({id: criticalLine.id, url: 'api/shipment'}).then(response => {})
      }
    },
    printCheckList (criticalLine) {
      if (criticalLine) {
        this.downloadCheck({id: criticalLine.id, url: 'api/shipment'}).then(response => {})
      }
    }, */
    save () {
      var criticalLine = JSON.parse(JSON.stringify(this.criticalLine))
      if (!this.criticalLine.id) {
        criticalLine = Object.assign({}, this.criticalLine, {company: this.company, user: this.userData.user.id})
      }
      if (!this.criticalLine.init_date || !this.criticalLine.end_date) {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('fill_mandatory') })
        return
      }
      this.saveCriticalLine(criticalLine).then(response => {
        this.$router.push('/critical-lines')
      })
    }
  }
}
</script>

<style scoped lang="scss">
#add-truck {
  display: table;
  min-width: 50%;
}
input, textarea {
  width: 100%;
  box-sizing: border-box;

}
textarea{
  resize: vertical;
}
.fields {
  padding: 0 3em;
}
.field-half-page {
  display: inline-block;
  width: 49.5%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageAddCriticalLine.vue